export type CosmeticUnlock = 'ion' | 'pulse-trail' | 'reactor' | 'faceted-shell' | 'nova' | 'ghost'

const UNLOCKS: readonly { distance: number; id: CosmeticUnlock }[] = [
  { distance: 0, id: 'ion' },
  { distance: 500, id: 'pulse-trail' },
  { distance: 1_500, id: 'reactor' },
  { distance: 3_000, id: 'faceted-shell' },
  { distance: 6_000, id: 'nova' },
  { distance: 10_000, id: 'ghost' },
]

export function calculateUnlocks(bestDistance: number): CosmeticUnlock[] {
  return UNLOCKS.filter((unlock) => bestDistance >= unlock.distance).map((unlock) => unlock.id)
}
